import {css, StyleSheet} from 'aphrodite';
import React, {useEffect, useState} from 'react';

import {Section} from 'constants/NavConstants';
import {OligoAwareFolderItemType} from 'constants/RegistryConstants';
import BioentitySearchView, {clearBioentitySearchViewSearchParams} from 'molbio/BioentitySearchView';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal, {ModalButton} from 'ui-library/modals/Modal';
import {RowSelectionMode} from 'ui-library/scrollable/ScrollableTableConstants';

interface ComponentSearchModalProps {
  rowSelectionMode: RowSelectionMode;
  availableTypes: Array<OligoAwareFolderItemType>;
  title: string;
  submitButtonText?: string;
  onRequestSubmit: (selectedIds: Array<string>) => void;
  onRequestClose: () => void;
}

export default function ComponentSearchModal({
  onRequestSubmit,
  onRequestClose,
  rowSelectionMode,
  availableTypes,
  title,
  submitButtonText,
}: ComponentSearchModalProps): JSX.Element {
  const [selectedBioentityIds, setSelectedBioentityIds] = useState<Array<string>>([]);

  const defaultButtonText =
    rowSelectionMode === RowSelectionMode.MULTIPLE ? 'Add Components' : 'Add Component';
  const buttons: Array<ModalButton> = [
    {text: 'Cancel', cancel: true},
    {
      text: submitButtonText ?? defaultButtonText,
      style: ButtonStyle.SECONDARY,
      submit: true,
      disabled: selectedBioentityIds.length === 0,
    },
  ];
  useEffect(() => {
    clearBioentitySearchViewSearchParams(availableTypes, Section.MODEL_HUB_STRUCTURE_PREDICTION);
  }, [availableTypes]);

  return (
    <Modal
      title={title}
      buttons={buttons}
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        onRequestSubmit?.(selectedBioentityIds);
      }}
      fullWidth={true}
      fullHeight={true}
      scrollable={false}
      bodyPadded={false}
    >
      <div className={css(styles.sequenceSearchView)}>
        <BioentitySearchView
          // TODO: Update this to be more configurable (eg allow for different nav sections)
          // after we setup the model hub nav section and action origin in the BE for analytics
          navSection={Section.MODEL_HUB_STRUCTURE_PREDICTION}
          availableTypes={availableTypes}
          selectedBioentityIds={selectedBioentityIds}
          setSelectedBioentityIds={setSelectedBioentityIds}
          rowSelectionMode={rowSelectionMode}
        />
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  sequenceSearchView: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});
